import request from '@/utils/request'

/**
 * 登录接口
 * @param {array} data 请求数据
 */
export function login(data) {
    return request({
      url: '/admin/login/login',
      method: 'post',
      data: data
    })
}


/**
 * 退出登录
 * @param {array} data 请求数据
 */
export function logout(data) {
  return request({
    url: '/admin/login/logout',
    method: 'post',
    data: data
  })
}
